<!--
 * @Author: your name
 * @Date: 2021-06-26 16:38:14
 * @LastEditTime: 2026-04-08 18:19:18
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\AttrList\AttrWeather.vue
-->
<!--天气-->

<template>
  <div class="attr-weather">
    <div class="weather-item flex-b-c">
      <span class="weather-attr">{{$t('PE.Name')}}</span>
      <span>{{$t('PE.Weather')}}</span>
    </div>
    <div class="weather-item flex-b-c">
      <span class="weather-attr">{{$t('PE.Address')}}</span>
      <!-- <el-select v-model="value" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>-->
      <el-cascader v-model="media.ext_val_cityCode" :options="citys" @change="cityChange" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;"></el-cascader>
    </div>
    <div class="weather-item flex-b-c">
      <span class="weather-attr">{{$t('PE.DisplayMode')}}</span>
      <div style="width: 130px;">
        <el-checkbox v-model="media.ext_val_bPlaceShow">{{$t('PE.City')}}</el-checkbox>
        <el-checkbox v-model="media.ext_val_wenduShow">{{$t('PE.Temp')}}</el-checkbox>
        <el-checkbox v-model="media.ext_val_bWindShow">{{$t('PE.WindPower')}}</el-checkbox>
        <el-checkbox v-model="media.ext_val_bHumidityShow">{{$t('PE.Humidity')}}</el-checkbox>
        <el-checkbox v-model="media.ext_val_bWearShow">{{$t('PE.DressingIndex')}}</el-checkbox>
      </div>
    </div>
    <div class="weather-item flex-b-c">
      <span class="weather-attr">{{$t('PE.DisplayUsage')}}</span>
      <el-radio-group v-model="media.ext_val_isSingleLine" style="width: 130px;" class="flex-b-c">
        <el-radio :label="true" style="margin-right: 12px;">{{$t('PE.ARow')}}</el-radio>
        <el-radio :label="false" style="margin-right: 12px;">{{$t('PE.MultiRow')}}</el-radio>
      </el-radio-group>
    </div>
    <div class="weather-item flex-b-c">
      <span class="weather-attr">{{$t('PE.FontFamily')}}</span>
      <div class="weather-attr-child" style="height: 96px;">
        <el-select v-model="media.ext_val_family" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
          <el-option v-for="item in familys" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <div style="width:130px;">
          <set-font-size @setFontSize="setFontSize" :defaultSize="media.ext_val_textSize"></set-font-size>
        </div>
        <!-- <el-select v-model="media.ext_val_textSize" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
          <el-option v-for="item in fontSize" :key="item" :label="item+'px'" :value="item"></el-option>
        </el-select>-->
        <div class="flex-a-c">
          <el-color-picker class="font-color-picker" v-model="media.ext_val_backgroundColor" size="mini" :title="$t('PE.BackgroundColor')" :show-alpha="true" :predefine="predefineColors"></el-color-picker>
          <el-color-picker class="font-color-picker" v-model="media.ext_val_textColor" size="mini" :title="$t('PE.FontColor')" :show-alpha="true" :predefine="predefineColors"></el-color-picker>
        </div>
      </div>
    </div>
    <div class="weather-item flex-b-c">
      <span class="weather-attr">{{$t('PE.EnterTheAnimation')}}</span>
      <el-select v-model="media.ext_val_anim" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
        <el-option v-for="item in animations" :key="item.id" :label="$t(item.i18n)" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="weather-item flex-b-c">
      <span class="weather-attr">{{$t('PE.TheEntryTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_enterTime" :min="1" size="mini"></el-input-number>
    </div>
    <div class="weather-item flex-b-c">
      <span class="weather-attr">{{$t('PE.PlayTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_duration" :min="1" :label="$t('PE.Describe')" size="mini"></el-input-number>
    </div>
  </div>
</template>

<script>
import familys from '@static/data/familys.js';
// import fontSize from '@static/data/fontSize.js';
import citys from '@static/data/city.json';
import SetFontSize from './children/SetFontSize';
import animations from '../../scripts/animations';
import predefineColors from '@static/data/predefineColors.js';
export default {
  name: "AttrWeather",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      predefineColors,
      animations,
      familys,
      // fontSize,
      citys,
      checkList: ""
    }
  },
  methods: {
    cityChange(citykey) {
      let city = this.citys.find((time) => time.value === citykey[0]).children.find((time) => time.value === citykey[1]).label;
      this.media.ext_val_city = city;
      this.media.ext_val_provinceCode = citykey[0];
      this.media.ext_val_cityCode = citykey[1];
    },
    setFontSize(val) {
      if (typeof (val) === "number") {
        this.media.ext_val_textSize = val;
      }
    },
  },
  components: {
    SetFontSize
  }
}
</script>

<style lang="scss" scoped>
.attr-weather {
  padding-right: 4px;
  .weather-item {
    min-height: 36px;
    margin: 8px 0px;
    .weather-attr {
      width: 100px;
      // font-family: "Times New Roman";
      // font-weight: normal;
      // font-stretch: normal;
      // color: #617883;
    }
    .weather-attr-child {
      width: 130px;
      height: 64px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
  .el-checkbox {
    margin-right: 12px;
  }
}
</style>